export enum Region {
  brussels = 'BRUSSELS',
  flanders = 'FLANDERS',
  wallonia = 'WALLONIA',
}
